import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "imageField"]

  select(event) {
    const selected = event.currentTarget.dataset.layout

    this.optionTargets.forEach(el => {
      el.classList.toggle("selected", el.dataset.layout === selected)
      const radio = el.querySelector("input[type=radio]")
      if (radio) radio.checked = el.dataset.layout === selected
    })

    this.imageFieldTargets.forEach(el => {
      el.style.display = (selected === "banner" || selected === "split") ? "" : "none"
    })
  }
}
